import React from 'react';
import { useTranslation } from 'react-i18next';
import { QButton } from '@qualio/ui-components';
import { Form } from '../../../../types';

type HeaderRevertToDraftButtonProps = {
  data: Form;
  shouldShowActionButton: boolean;
  callback: () => void;
  isDisabled?: boolean;
  isApiLoading?: boolean;
};

export const HeaderRevertToDraftButton: React.FC<HeaderRevertToDraftButtonProps> = ({
  data,
  shouldShowActionButton = false,
  callback,
  isDisabled = false,
  isApiLoading = false,
}) => {
  const { t } = useTranslation();
  const shouldShowRevertToDraftButton =
    ['approval_declined', 'for_review', 'for_approval'].includes(data.status) && shouldShowActionButton;

  return shouldShowRevertToDraftButton ? (
    <QButton
      aria-label="revert-to-draft"
      data-cy="revert-to-draft"
      variant="outline"
      isLoading={isApiLoading}
      isDisabled={isDisabled}
      onClick={callback}
    >
      {t('forms.actions.revertToDraft')}
    </QButton>
  ) : null;
};
